/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const postSlider = () => {
  const carousel = document.querySelector('.js-post-slider');

  jQuery(carousel).slick({
    dots: true,
    speed: 750,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
  });

  // jQuery(document).on("click", ".js-more-btn", (e) => {
  //     jQuery(e.target).prev().find('.c-post-slider__content').toggleClass('u-hidden');
  //     jQuery(e.target).addClass('u-hidden');
  // });
};

export default postSlider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/factory-logistic-chisel/src/scripts/modules/postSlider.js